import { Spacer, Text } from '@loomhq/lens';
import classNames from 'classnames';
import React from 'react';

import { getCloudfrontURI } from 'utilities/avatar';
import { sanitizeContent } from 'utilities/comments';

import EnsureInsideContainer from '../ensure-inside-container';

import UserAvatar from 'components/user-avatar';

import styles from './styles.module.less';

const COMMENT_BUBBLE_PADDING = 8;

const CommentBubble = props => {
  const {
    avatar,
    commentBarRef,
    commentCount,
    content,
    onClick,
    onTop,
    percentageLeft,
    userName,
  } = props;

  const classnames = classNames(styles.commentBubble, {
    [styles.onTop]: onTop,
  });

  const handleClick = e => {
    e.stopPropagation();
    onClick();
  };

  const onMouseDown = e => {
    // We need to catch the mouseDown event, otherwise the seek bar will get it and jump the playback.
    e.stopPropagation();
  };

  const sanitizedContent = sanitizeContent({ content });
  const contentFirstLine = sanitizedContent.split('<br>')[0];

  return (
    <EnsureInsideContainer
      percentageLeft={percentageLeft}
      parentRef={commentBarRef}
      horizontalPadding={COMMENT_BUBBLE_PADDING}
    >
      <div
        onClick={handleClick}
        onMouseDown={onMouseDown}
        className={classnames}
      >
        <UserAvatar
          className={styles.avatar}
          size="3"
          avatarSrc={avatar && getCloudfrontURI(avatar)}
          name={userName}
        />
        <Spacer left="1" />
        <div className={styles.textWrapper}>
          <Text className={styles.commentText} size="small" color="grey1">
            <div
              className={styles.textHtmlContent}
              dangerouslySetInnerHTML={{ __html: contentFirstLine }}
            />
          </Text>
          {Boolean(commentCount) && (
            <Text className={styles.subText} size="small" color="grey1">
              +{commentCount} other {commentCount > 1 ? 'comments' : 'comment'}
            </Text>
          )}
        </div>
      </div>
    </EnsureInsideContainer>
  );
};

export default CommentBubble;
